import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Confirm from 'components/AppCart/GenericApps/Confirm/Confirm';

const REDIRECT_DELAY_MS = 10000;
const CHALLENGE_RESPONSE_PATH = '/ChallengeResponseValidation';

/**
 * Confirmation page displayed after a successful challenge-response submission.
 * Automatically redirects the user back to the form after a short delay.
 *
 * @returns {import('react').ReactElement} Challenge-response submission confirmation page.
 */
const ChallengeResponseConfirmation = () => {
	const history = useHistory();

	useEffect(() => {
		const redirectTimer = setTimeout(() => {
			history.push(CHALLENGE_RESPONSE_PATH);
		}, REDIRECT_DELAY_MS);

		return () => clearTimeout(redirectTimer);
	}, [history]);

	const onMakeAnotherRequestHandler = () => {
		history.push(CHALLENGE_RESPONSE_PATH);
	};

	return (
		<Confirm bannerMessage='Your Challenge Response request has been submitted for further processing.'>
			<Box sx={{ textAlign: 'center', mt: 2 }}>
				<Typography>
					Please click{' '}
					<Link component='button' onClick={onMakeAnotherRequestHandler}>
						Here
					</Link>{' '}
					to make another request.
				</Typography>
				<Typography sx={{ mt: 1 }}>
					If page does not automatically redirect in 10 seconds, please use the
					link above.
				</Typography>
			</Box>
		</Confirm>
	);
};

export default ChallengeResponseConfirmation;
